import { useRef, useCallback } from 'react';

export const useSound = () => {
  const audioRef = useRef(null);

  const playSound = useCallback((soundType = 'message') => {
    // Создаем audio элемент если его нет
    if (!audioRef.current) {
      audioRef.current = new Audio();
    }

    const soundFile = soundType === 'message' 
      ? '/sounds/social-media-logout-sound.mp3'
      : '/sounds/message-notification-sound-imassage-on-iphone.mp3';

    audioRef.current.src = soundFile;
    audioRef.current.volume = 0.6; // Устанавливаем громкость (0-1)
    
    // Сбрасываем текущее время воспроизведения
    audioRef.current.currentTime = 0;
    
    // Воспроизводим звук
    const playPromise = audioRef.current.play();
    
    if (playPromise !== undefined) {
      playPromise.catch(error => {
        console.log('Ошибка воспроизведения звука:', error);
      });
    }
  }, []);

  const stopSound = useCallback(() => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
  }, []);

  return { playSound, stopSound };
};